import { render, staticRenderFns } from "./TeamCard.vue?vue&type=template&id=583ce55a&scoped=true"
import script from "./TeamCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamCard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TeamCard.vue?vue&type=style&index=0&id=583ce55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583ce55a",
  null
  
)

export default component.exports